import React from 'react';
import { Row, Col, Card, Statistic, Icon } from 'antd';
import { Link } from 'react-router';

import Layout from '../../components/layout/Layout';
import Loading from '../../elements/Loading';
import CustomIcon from '../../elements/Icon';

import './statistics.scss';

export default function () {
    const { dashboard } = this.props;
    const { stats, isFetching } = dashboard;

    if (isFetching) {
        return (
            <Layout title={this.state.title} breadcrumb="statistics">
                <div className="container mt-3">
                    <Loading />
                </div>
            </Layout>
        );
    }

    return (
        <Layout title={this.state.title} breadcrumb="statistics">
            <div className="container mt-3">
                <div className="section">
                    {/* Overview Statistics Cards */}
                    <Row gutter={16} style={{ marginBottom: '24px' }}>
                        <Col span={8}>
                            <Card>
                                <Statistic
                                    title="Total Orders"
                                    value={stats.orders}
                                    prefix={<Icon type="shopping-cart" />}
                                    valueStyle={{ color: '#3f8600' }} />
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card>
                                <Statistic
                                    title="Total Customers"
                                    value={stats.customers}
                                    prefix={<Icon type="user" />}
                                    valueStyle={{ color: '#1890ff' }} />
                            </Card>
                        </Col>
                        <Col span={8}>
                            <Card>
                                <Statistic
                                    title="Care Homes"
                                    value={stats.carehomes}
                                    prefix={<Icon type="home" />}
                                    valueStyle={{ color: '#722ed1' }} />
                            </Card>
                        </Col>
                    </Row>

                    {/* Customer Breakdown */}
                    <Row gutter={16} style={{ marginBottom: '24px' }}>
                        <Col span={12}>
                            <Card>
                                <Statistic
                                    title="Active Customers"
                                    value={stats.customers_active}
                                    prefix={<Icon type="user" />}
                                    valueStyle={{ color: '#3f8600' }} />
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card>
                                <Statistic
                                    title="Inactive Customers"
                                    value={stats.customers_inactive}
                                    prefix={<Icon type="user" />}
                                    valueStyle={{ color: '#cf1322' }} />
                            </Card>
                        </Col>
                    </Row>

                    {/* Practices Card */}
                    <Row gutter={16} style={{ marginBottom: '24px' }}>
                        <Col span={24}>
                            <Card>
                                <Statistic
                                    title="Total Practices"
                                    value={stats.practices}
                                    prefix={<Icon type="medicine-box" />}
                                    valueStyle={{ color: '#fa8c16' }} />
                            </Card>
                        </Col>
                    </Row>

                    {/* Navigation Icons */}
                    <Row gutter={16}>
                        <Col span={24}>
                            <Card title="Quick Navigation" style={{ textAlign: 'center' }}>
                                <Row gutter={32}>
                                    <Col span={6}>
                                        <Link to="/customers" style={{ textDecoration: 'none' }}>
                                            <div style={{ padding: '20px', cursor: 'pointer' }}>
                                                <div style={{ marginBottom: '10px' }}>
                                                    <CustomIcon
                                                        name="customers"
                                                        className="nav-icon" />
                                                </div>
                                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                                                    Customers
                                                </div>
                                            </div>
                                        </Link>
                                    </Col>
                                    <Col span={6}>
                                        <Link to="/orders" style={{ textDecoration: 'none' }}>
                                            <div style={{ padding: '20px', cursor: 'pointer' }}>
                                                <div style={{ marginBottom: '10px' }}>
                                                    <CustomIcon
                                                        name="order"
                                                        className="nav-icon" />
                                                </div>
                                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                                                    Orders
                                                </div>
                                            </div>
                                        </Link>
                                    </Col>
                                    <Col span={6}>
                                        <Link to="/admin" style={{ textDecoration: 'none' }}>
                                            <div style={{ padding: '20px', cursor: 'pointer' }}>
                                                <div style={{ marginBottom: '10px' }}>
                                                    <CustomIcon
                                                        name="admin"
                                                        className="nav-icon" />
                                                </div>
                                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                                                    Admin
                                                </div>
                                            </div>
                                        </Link>
                                    </Col>
                                    <Col span={6}>
                                        <Link to="/reports" style={{ textDecoration: 'none' }}>
                                            <div style={{ padding: '20px', cursor: 'pointer' }}>
                                                <div style={{ marginBottom: '10px' }}>
                                                    <CustomIcon
                                                        name="report"
                                                        className="nav-icon" />
                                                </div>
                                                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
                                                    Reports
                                                </div>
                                            </div>
                                        </Link>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}
